var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useMemo, useState } from 'react';
import { useLoaderData } from 'react-router';
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Translate } from "../../../../I18N";
import { useAtomValue } from 'jotai';
import { templatesAtom } from "../../../atoms";

import { Button } from "../../../Components/UI";

import { formatExtractors } from "./utils/formatters";
import { CreateDialog } from "./components/extractors/CreateDialog";
import { ExtractorsTable } from "./components/extractors/Table";
import { DeleteDialog } from "./components/extractors/DeleteDialog";

const ParagraphExtractorDashboard = () => {
  const { extractors = [] } = useLoaderData();


  const templates = useAtomValue(templatesAtom);
  const [isSaving, setIsSaving] = useState(false);
  const [selected, setSelected] = useState([]);
  const [deletedialogIsopen, setdeletedialogIsopen] = useState(false);
  const [createDialogIsopen, setCreateDialogIsopen] = useState(false);

  const paragraphExtractorData = useMemo(
    () => formatExtractors(extractors, templates),
    [extractors, templates]
  );

  return (/*#__PURE__*/
    _jsx("div", { className: "h-full w-full overflow-y-auto", "data-testid": "settings-paragraph-extractor" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Paragraph extraction" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(ExtractorsTable, {
      paragraphExtractorData: paragraphExtractorData,
      onSelectionChange: setSelected }
    ), /*#__PURE__*/
    _jsx(DeleteDialog, {
      setIsProcessing: setIsSaving,
      onSuccess: () => {
        setSelected([]);
      },
      selected: selected,
      isOpen: deletedialogIsopen,
      setIsOpen: setdeletedialogIsopen }
    ), /*#__PURE__*/
    _jsx(CreateDialog, { isOpen: createDialogIsopen, setIsOpen: setCreateDialogIsopen })
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, { className: "flex gap-2", highlighted: (selected === null || selected === void 0 ? void 0 : selected.length) > 0 }, void 0,
    selected !== null && selected !== void 0 && selected.length ? /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2 " }, void 0, /*#__PURE__*/
    _jsx(Button, { color: "error", type: "button", onClick: () => setdeletedialogIsopen(true) }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx("div", { className: "text-gray-500" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), /*#__PURE__*/
    _jsx("span", { className: "font-semibold text-gray-900" }, void 0, selected.length), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of"), /*#__PURE__*/
    _jsx("span", { className: "font-semibold text-gray-900" }, void 0, paragraphExtractorData.length)
    )
    ) : /*#__PURE__*/

    _jsx(Button, { type: "button", onClick: () => setCreateDialogIsopen(true), disabled: isSaving }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add extractor")
    )

    )
    )
    ));

};

export { ParagraphExtractorDashboard };